import React, { useState, useEffect } from "react";
import useHttp from "../../../../hooks/use-http";
import { toast } from "react-toastify";

const ReportServiceFieldAllocateForm = (props) => {
  const [reportList, setReportList] = useState([]);
  const [reportName, setReportName] = useState("");
  const [fieldDetails, setFieldDetails] = useState([]);
  const [reportId, setReportId] = useState(null);
  const { sendRequest: fetchReports } = useHttp();
  const { sendRequest: postReportFields } = useHttp();

  useEffect(() => {
    fetchReports(
      {
        url: `/api/reportService/?orgId=${localStorage.getItem("orgId")}`,
      },
      (res) => {
        if (res) setReportList(res);
      }
    );
  }, []);

  useEffect(() => {
    if (props.update && props.update.reportServiceName) {
      const report = props.update;
      setReportName(report.reportServiceName);
      setReportId(report.reportServiceFieldAllocateId);
      setFieldDetails(
        report.fieldDetail.map((f) => ({
          ...f,
          checked: f.status === 1,
        }))
      );
    }
  }, [props.update]);

  const handleReportChange = (e) => {
    const selected = e.target.value;
    setReportName(selected);
    const report = reportList.find((r) => r.reportServiceName === selected);
    if (report) {
      setReportId(report.reportServiceFieldAllocateId);
      setFieldDetails(
        report.fieldDetail.map((f) => ({
          ...f,
          checked: f.status === 1,
        }))
      );
    } else {
      setFieldDetails([]);
    }
  };

  const handleFieldToggle = (index) => {
    setFieldDetails((prev) =>
      prev.map((f, i) => (i === index ? { ...f, checked: !f.checked } : f))
    );
  };

  const submitHandler = (e) => {
    e.preventDefault();

    const reportToUpdate = props.update
      ? props.update
      : reportList.find((r) => r.reportServiceName === reportName);

    if (!reportToUpdate) {
      toast.error("No matching report to update.");
      return;
    }

    const reportId = reportToUpdate.reportServiceFieldAllocateId;
    if (!reportId) {
      toast.error("Report ID is missing. Cannot update.");
      return;
    }

    const updatedPayload = {
      fieldDetail: fieldDetails.map((f, index) => ({
        dataField: f.dataField,
        headerField: f.headerField,
        status: f.checked ? 1 : 0,
        sequenceNo: index + 1,
      })),
    };

    postReportFields(
      {
        url: `/api/reportService/${reportId}/`,
        method: "PUT",
        body: updatedPayload,
      },
      (res) => {
        if (res?.message === "Report updated successfully") {
          toast.success(res.message);
          props.onSuccess?.();
          props.addForm(false);
        } else {
          toast.error("Field details update failed (check backend response).");
        }
      }
    );
  };

  return (
    <div className="content-wrapper">
      <section className="content">
        <div className="container-fluid">
          <div className="card card-default">
            <form onSubmit={submitHandler}>
              <div className="card-header">
                <h3 className="card-title">
                  Report Service Field Allocate Form
                </h3>
                <div className="card-tools">
                  <button
                    type="button"
                    className="btn btn-tool"
                    onClick={() => props.addForm(false)}
                  >
                    <i className="fas fa-times" />
                  </button>
                </div>
              </div>

              <div className="card-body">
                <div className="row">
                  <div className="col-md-1" />
                  <div className="col-md-4">
                    <div className="form-group">
                      <label>Report Name</label>
                      <select
                        className="form-control"
                        value={reportName}
                        onChange={handleReportChange}
                        required
                        disabled={props.update ? true : false}
                      >
                        <option value="">Select</option>
                        {reportList.map((report) => (
                          <option
                            key={report.reportServiceFieldAllocateId}
                            value={report.reportServiceName}
                          >
                            {report.reportServiceName}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                </div>

                {fieldDetails.length > 0 && (
                  <div className="row mt-3">
                    <div className="col-md-12">
                      <div className="row">
                        {fieldDetails.map((field, index) => (
                          <div className="col-md-3 mb-2" key={field.dataField}>
                            <div className="form-check">
                              <input
                                type="checkbox"
                                className="form-check-input"
                                id={`field-${index}`}
                                checked={field.checked}
                                onChange={() => handleFieldToggle(index)}
                              />
                              <label
                                className="form-check-label"
                                htmlFor={`field-${index}`}
                              >
                                {field.headerField}
                              </label>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                )}

                <div className="text-right mt-3">
                  <button type="submit" className="btn btn-primary">
                    {props.update ? "Update" : "Submit"}
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ReportServiceFieldAllocateForm;
